import gql from 'graphql-tag';

const ADD_MANUAL_ON_VENUE_TO_CNID_MAPPING = gql`
  mutation addManualONVenueToCNIdMapping(
    $params: AddManualONVenueToCNIdMappingInput!
  ) {
    addManualONVenueToCNIdMapping(params: $params) {
      onvenue {
        name
        uuid
      }

      cnvenue {
        name
        uuid
      }
    }
  }
`;

export default ADD_MANUAL_ON_VENUE_TO_CNID_MAPPING;
